import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';

import { useTypedSelector } from '../../../../hooks';
import { useNotification } from '../../../../hooks/useNotification';
import { CirclePerson2, Toast } from '../../../../brenger-shared-ui';
import { getQuote } from '../../ducks';
import { getLocation } from 'connected-react-router';

export const ProductSelectionFloorService: React.FC = () => {
  const notification = useNotification('product-selection--floor-service');
  const { pathname } = useTypedSelector(getLocation);
  const floorServiceAvailability = useTypedSelector(getQuote)?.service_advisory?.floor_service;

  React.useEffect(() => {
    if (pathname.includes('floor') && floorServiceAvailability === 'warn') {
      notification.add();
    } else if (pathname.includes('contact') && floorServiceAvailability === 'not_available') {
      notification.add();
    } else {
      notification.remove();
    }
  }, [pathname, floorServiceAvailability]);

  return (
    <Toast
      isVisible={notification.isVisible}
      prefix={<CirclePerson2 />}
      handleClose={notification.removeForOneSession}
      title={
        <Translate id={`request_flow.product_selection.notification.floor_service_${floorServiceAvailability}.title`} />
      }
      body={
        <Translate id={`request_flow.product_selection.notification.floor_service_${floorServiceAvailability}.text`} />
      }
    />
  );
};
